import { useState, useEffect, useRef, type ChangeEvent, type KeyboardEvent } from "react";
import Modal from "@modalSrc/Modal";

type NewEntityModalProps = {
  isOpen: boolean;
  entityName: string;
  onSave: (value: string) => void;
  onClose: () => void;
  label?: string;
};

export default function NewEntityModal({ isOpen, entityName, onSave, onClose, label }: NewEntityModalProps) {
  const [value, updateValue] = useState("");
  const inputRef = useRef<HTMLInputElement | null>(null);

  // Clear input value when modal is closed and reopened
  useEffect(() => {
    if (isOpen) {
      updateValue("");
      // Focus the input when the modal opens
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 0);
    }
  }, [isOpen]);

  if (!isOpen)
    return null;

  function handleInputChange(e: ChangeEvent<HTMLInputElement>) {
    updateValue(e.target.value);
  }

  function handleKeyDown(e: KeyboardEvent<HTMLInputElement>) {
    if (e.key === 'Enter') {
      CloseModal();
    }
  }

  function CloseModal() {
    onSave(value);
    onClose();
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`New ${entityName}`}
      footer={<button className="btn btn-primary" onClick={CloseModal}>Create {entityName}</button>}
    >
      <div className="">
        <input
          type="text"
          className="block"
          value={value}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={label || "Name"}
          ref={inputRef}
        />
      </div>
    </Modal>
  );
}

